import classNames from 'classnames';

const cx = classNames;

function AddressUser() {
    return (
        <div className={cx('bg-blue-100 text-8xl font-semibold w-screen h-[600px] flex items-center justify-center')}>
            ADDRESSUSER
        </div>
    );
}

export default AddressUser;
